/**
 * Zendesk Help Center URL resolver — JS mirror of App\Support\HelpCenterUrl.
 *
 * Builds `https://support.vignetteslovenia.si/hc/{locale}/` from a CMS language
 * record (one of `store.getters.languages` / `$__languages`) or a raw code
 * string. The Zendesk slug is derived from the language's `code` / `ref_code`,
 * so the list of supported languages comes from CMS data — no per-language
 * URL is hardcoded here.
 *
 * The only Zendesk-specific quirk we encode is English: our Help Center
 * default locale is UK English (`en-gb`), not US (`en-us`).
 */

const HELP_CENTER_BASE = 'https://support.vignetteslovenia.si/hc/'
const DEFAULT_LOCALE = 'en-gb'
const ENGLISH_LANGUAGE_CODE = 'en'

const HELP_CENTER_HINTS = Object.freeze([
    'helpcenter',
    'help-center',
    'help_center',
    'support.vignetteslovenia.si',
    'support.vignetteslovenia.com',
    'vignetteslovenia.zendesk.com',
])

function extractLanguageCode(lang) {
    if (lang == null) return ''
    const raw = typeof lang === 'object'
        ? (lang.code || lang.ref_code)
        : lang
    const normalized = String(raw || '').trim().toLowerCase().replace(/_/g, '-')
    if (normalized === '') return ''
    return normalized.split('-')[0]
}

function normalizeLocale(lang) {
    const code = extractLanguageCode(lang)
    if (code === '' || code === ENGLISH_LANGUAGE_CODE) {
        return DEFAULT_LOCALE
    }
    return code
}

function resolveHelpCenterUrl(lang) {
    return `${HELP_CENTER_BASE}${normalizeLocale(lang)}/`
}

function isHelpCenterHref(href) {
    if (href == null) return false
    const haystack = String(href).toLowerCase()
    return HELP_CENTER_HINTS.some((hint) => haystack.includes(hint))
}

function resolveMenuHref(path, lang) {
    if (isHelpCenterHref(path)) {
        return resolveHelpCenterUrl(lang)
    }
    return (path && String(path).trim() !== '') ? path : '#'
}

export {
    HELP_CENTER_BASE,
    normalizeLocale,
    resolveHelpCenterUrl,
    isHelpCenterHref,
    resolveMenuHref,
}
